import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/modules/shared.module';
import { CommonModule } from '@angular/common';
import { TemplateListComponent } from './template-list/template-list.component';
import { TemplateAddUpdComponent } from './template-add-upd/template-add-upd.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        SharedModule,
        ReactiveFormsModule
    ],
    exports: [],
    declarations: [
        TemplateListComponent,
        TemplateAddUpdComponent
    ],
    providers: [],
})
export class TemplateModule { }
